import { render, staticRenderFns } from "./AddVaccinationData.vue?vue&type=template&id=7bb462f0&scoped=true&"
import script from "./AddVaccinationData.vue?vue&type=script&lang=js&"
export * from "./AddVaccinationData.vue?vue&type=script&lang=js&"
import style0 from "./AddVaccinationData.vue?vue&type=style&index=0&id=7bb462f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb462f0",
  null
  
)

export default component.exports